import { environment } from "@/environment";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { User } from "oidc-client-ts";

const baseQuery = fetchBaseQuery({
  baseUrl: environment.backendUrl,
  prepareHeaders: (headers) => {
    const oidcStorage = sessionStorage.getItem(
      `oidc.user:${environment.oidc.authority}:${environment.oidc.client_id}`,
    );
    if (oidcStorage) {
      const user: User = User.fromStorageString(oidcStorage);
      headers.set("Authorization", `Bearer ${user.access_token}`);
    }
  },
});

export const tumtutorApi = createApi({
  reducerPath: "tumtutorApi",
  baseQuery: baseQuery,
  tagTypes: [
    "course",
    "material",
    "chat",
    "user",
    "question",
    "tip",
    "chatSession",
    "notification",
    "university",
    "survey",
  ],
  endpoints: () => ({}),
});

export const { invalidateTags } = tumtutorApi.util;
